var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NewsCard',_vm._b({attrs:{"type":"cover","base-path":_vm.basePath,"hide-date":_vm.hideDate}},'NewsCard',{ id: _vm.id, title: _vm.title, img: _vm.image },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }